module.exports = __webpack_public_path__ + "img/bg_avatar_male_58.9f4104dd.png";